import { render, staticRenderFns } from "./MailTemplateList.vue?vue&type=template&id=33d4e35b&scoped=true&"
import script from "./MailTemplateList.vue?vue&type=script&lang=js&"
export * from "./MailTemplateList.vue?vue&type=script&lang=js&"
import style0 from "./MailTemplateList.vue?vue&type=style&index=0&id=33d4e35b&lang=scss&scoped=true&"
import style1 from "./MailTemplateList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d4e35b",
  null
  
)

export default component.exports